import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=7d56e64a&"
import script from "./BasicTable.vue?vue&type=script&lang=js&"
export * from "./BasicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports